import React from "react";
import Tooltip from 'react-tooltip';
import { MdInfo } from "react-icons/md";

const divStyle = {  
    height: '15px',
    width: '15px',
    marginLeft: '5px'
};

  export const Info = ({ info, id }) => {
    return (
        <div style={divStyle} data-tip={info} data-for={id}> <MdInfo /> <Tooltip id={id}/> </div>
    )
}